 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Has been modified. Do not replace. - Michael Large
 *
 * Creates and uses srcSet attributes for background images.
 * @author Jesse Kernaghan <https://github.com/jessekernaghan/bgsrcset.js>
 */
(function () {
  'use strict';

  var bgsrcset = function bgsrcset() {

    this.called = false;
    this.callonce = true;
    this.compat();
  };

  bgsrcset.prototype.init = function (target, callback) {
    //retina bool
    this.retina = window.devicePixelRatio > 1;

    //storage for our elements
    this.elements = [];

    //global onload callback for imagery
    this.callback = typeof callback === 'function' ? callback : function () {};

    //window width, for responsive handling
    this.curwidth = this.getWidth();

    //get our input and turn it into an element list of some sort
    //   var elems = this.gather(target);
    var elems = document.querySelectorAll('[data-bg-srcset]');

    //parse the element input
    for (var i = 0, l = elems.length; i < l; i++) {
      this.parse(elems[i]);
    }

    this.set();
    this.resize();
  };

  /* -----------* /
     Fix compatibility issues*
     *only down to IE8
  / *----------- */

  bgsrcset.prototype.compat = function () {
    var d = document;
    /* check for getElementsByClassName */
    if (typeof d.getElementsByClassName !== 'function') {
      d.getElementsByClassName = function (str) {
        return d.querySelectorAll('.' + str);
      };
    }

    /* check for .trim() */
    if (!String.prototype.trim) {
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }

    /*------------------------* /
      Check for Event Listener
    / *------*/
    if (!d.addEventListener) {
      this.addEvent = function (elem, evName, fn) {
        elem.attachEvent('on' + evName, function (e) {
          fn(e || window.event);
        });
      };
    }
  };

  /* -----------* /
     Gather elements
  / *----------- */

  bgsrcset.prototype.gather = function (target) {
    var autotypes = ['HTMLCollection', 'NodeList'];
    var e = target;
    var type = e.nodeType ? 'Object' : Object.prototype.toString.call(e).replace(/^\[object |\]$/g, '');

    var func = 'parse' + type;

    if (autotypes.indexOf(type) > -1) {
      return e;
    }

    if (this[func]) {
      return this[func](e);
    }

    return [];
  };

  bgsrcset.prototype.parseObject = function (target) {
    return target.nodeType ? [target] : [];
  };

  bgsrcset.prototype.parseArray = function (target) {
    return target;
  };

  bgsrcset.prototype.parseString = function (target) {

    var d = document;
    var e = target.trim();
    var sel = e[0];
    var elems = [];

    switch (true) {
      /* class */
      case sel === '.':
        elems = d.getElementsByClassName(e.substring(1));
        break;
      /* id */
      case sel === '#':
        elems.push(d.getElementById(e.substring(1)));
        break;
      /* tag */
      case /^[a-zA-Z]+$/.test(e):
        elems = d.getElementsByTagName(e);
        break;
      /* unknown */
      default:
        elems = [];
    }

    return elems;
  };

  /* -----------* /
     Parse datasrc
  / *----------- */
  bgsrcset.prototype.parse = function (obj) {
    //our data to parase
    var bgss = obj.dataset.bgSrcset;
    /* exit if no attribute */
    if (attr === null) {
      console.log("NO BG SRCSET");return false;
    }

    /* create new element object */
    this.elements.push({});

    /* split up sets */
    var set = bgss.split(',');
    var attr = '';
    var curelem = this.elements[this.elements.length - 1];

    curelem.node = obj;
    curelem.srcset = [];

    /* loop through sets to define breakpoints */
    for (var i = 0, l = set.length; i < l; i++) {
      curelem.srcset.push({});
      attr = set[i].trim();
      var attrs = attr.split(' ');
      var a;
      var e;
      var t;
      /* since we can't know the order of the values, starting another loop */
      for (var attrc = 0, attrl = attrs.length; attrc < attrl; attrc++) {
        a = attrs[attrc];
        e = curelem.srcset[i]; //current attribute
        t = a.length - 1;
        switch (true) {
          case a.trim() === "":
            //in case of extra white spaces
            continue;
          case a[t] !== 'w' && a[a.length - 1] !== 'x':
            e.src = a;
            break;
          case a[t] === 'w':
            e.width = parseInt(a.slice(0, -1));
            break;
          case a[t] === 'x':
            e.retina = parseInt(a.slice(0, -1)) > 1;
            break;
        }
        if (!e.width) {
          e.width = Number.POSITIVE_INFINITY;
        } //set to the top
        if (!e.retina) {
          e.retina = false;
        }
      }
    }
  };

  /* -----------* /
     Set image
  / *----------- */
  bgsrcset.prototype.set = function () {
    for (var i = 0, l = this.elements.length; i < l; i++) {
      this.setSingle(i);
    }
  };

  bgsrcset.prototype.setSingle = function (id) {
    var width = 0,
        elem = this.elements[id],
        comparray = [],
        best = 0,
        _this = this;

    //      width = this.getWidth(); //elem.node.offsetWidth;
    // 2017-10-06, use the container width and not window width. Experiemental.
    width = elem.node.offsetWidth;

    elem.srcset = elem.srcset.sort(dynamicSort("width"));

    for (var i = 0, l = elem.srcset.length; i < l; i++) {
      if (elem.srcset[i].width < width) {
        continue;
      }
      comparray.push(elem.srcset[i]);
    }
    if (comparray.length === 0) {
      comparray.push(elem.srcset[elem.srcset.length - 1]);
    }

    best = comparray[0];

    if (comparray.length > 1 && comparray[0].width === comparray[1].width) {
      best = comparray[0].retina !== this.retina ? comparray[1] : comparray[0];
    }

    if (best.src !== undefined && best.src !== 'null') {
      var img = new Image();
      var done = false;

      img.onload = img.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
          done = true;

          elem.node.style.backgroundImage = "url('" + best.src + "')";

          /* only fire the callback on initial load, not resize events */
          if (!_this.called) {

            _this.callback(elem);
            _this.called = _this.callonce;
          }
        }
      };

      img.src = best.src;
    } else {
      elem.node.style.backgroundImage = "";
    }
  };

  /* -----------* /
     Handle Resize
  / *----------- */
  bgsrcset.prototype.resize = function () {
    var _this = this,
        resizeTimer = setTimeout(function () {}, 0);

    this.addEvent(window, 'resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = _this.getWidth();
        if (w !== _this.curwidth) {
          _this.curwidth = w;
          _this.set();
        }
      }, 250);
    });
  };

  bgsrcset.prototype.addEvent = function (elem, evName, fn) {
    elem.addEventListener(evName, fn, false);
  };

  bgsrcset.prototype.getWidth = function () {
    var w, d, e, g;
    w = window;
    d = document;
    e = d.documentElement;
    g = d.getElementsByTagName('body')[0];

    return w.innerWidth || e.clientWidth || g.clientWidth;
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;a;
    };
  }

  window.bgsrcset = bgsrcset;
})();

// Creates SourceSet for background images.
var bgss = new bgsrcset();
bgss.init('.bgimg'); // Re-called in debug.js
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
     if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
     } else var expires = "";
     document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
     var nameEQ = name + "=";
     var ca = document.cookie.split(';');
     for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
               c = c.substring(1, c.length);
          }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
     }
     return null;
}
function eraseCookie(name) {
     setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * DBS Chevron hover
 */
window.addEventListener('load', function () {
	jQuery('#dbs-chev').on('click', function () {
		jQuery(this).toggleClass('hover');
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce(func, wait, immediate) {
  var timeout;
  if (!wait) {
    console.warn("Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective.");
  }
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */

/**
 * A cross-browser compatible event creator function.
 */
function create_event(event_name) {
  if (typeof Event === 'function') {
    var event = new Event(event_name);
  } else {
    var event = document.createEvent('Event');
    event.initEvent(event_name, true, true);
  }
  return event;
}

var debounceScroll = create_event('debounceScroll');

window.addEventListener('load', function () {
  var delay_time = 50;
  var delay_start = 0;
  var last_scroll_pos = 0;
  // The one scroll event handler to rule them all.
  jQuery(window).scroll(function (event) {
    // If we are already scrolling, reset the delay
    if (delay_start) {
      clearTimeout(delay_start);
    }

    // Are we scrolling down?
    var scrollDown = $(window).scrollTop() > last_scroll_pos;
    last_scroll_pos = $(window).scrollTop(); // Save for next time

    delay_start = setTimeout(function (event) {
      debounceScroll.scrollDown = scrollDown;
      window.dispatchEvent(debounceScroll);
    }, delay_time);
  });
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Elements for extending the DOM with useful functionality.
 *
 * Note that caution should be used here as to prevent name collisions.
 * Probably only super useful functions should be included here.
 *
 * @usage:
 *
 * 	var element = document.getElementById( 'the_id' );
 *
 * 	element.onClickTap( function() {
 * 		// Do something useful when clicked or tapped but not dragged.
 * 		// Ignores annoying phantom clicks.
 * 	});
 *
 *
 * @author HGB3 12/22/2016
 */

/**
 * Sets up an event handler for both tap and click events in such a way
 * that we prevent "phantom taps" -- when both the click event and the
 * touchend events are fired for one event. Also tests for and ignores
 * drag events.
 *
 * @param function handler - the function to handle the event
 * @param element - element on which to put the events
 */
Element.prototype.onClickTap = function (handler, element) {
	var element = element || this; // Create a closure on the element

	var dragging = false; // Create a closure on a dragging flag

	/**
  * Notice and flag drag events to ignore.
  */
	jQuery(element).on('touchmove', function (event) {
		dragging = true;
	});

	/**
  * Handles touchend events (when not dragging).
  */
	jQuery(element).on('touchend', function (event) {
		if (!dragging) {
			handler(event);
		}
		dragging = false; // We are at the end of the 'touch', so reset dragging flag
		element.tapEventHandled = true;
	});

	/**
  * When this event is fired, check to see if the element's
  * tabEventHandled flag was set. If so, unset it.
  * If not, handle the event like normal.
  */
	jQuery(element).on('click', function (event) {
		if (element.tapEventHandled) {
			element.tapEventHandled = false;
			return;
		}
		if (!dragging) {
			handler(event);
		}
	});
};

/**
 * Sets up an event handler for *only* click events. Tap events, which
 * should happen first, will prevent the handler from being run.
 *
 * @param function handler - the function to handle the event
 */
Element.prototype.onClickTap = function (handler, element) {
	var element = element || this; // Create a closure on the element

	/**
  * Handles touchstart events.
  */
	jQuery(element).on('touchstart', function (event) {
		element.tapEventHappened = true;
	});

	/**
  * When this event is fired, check to see if the element's
  * tabEventHandled flag was set. If so, unset it for the next time.
  * If not, handle the event like normal.
  */
	jQuery(element).on('click', function (event) {
		if (element.tapEventHappened) {
			element.tapEventHappened = false;
		} else {
			handler(event);
		}
	});
};
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/*
* Plugin Name: Resize Image to Parent Container
*
* Author: Christian Varga
* Author URI: http://christianvarga.com
* Plugin Source: https://github.com/levymetal/jquery-resize-image-to-parent/
*
*/

(function ($) {
	$.fn.resizeToParent = function (opts) {
		var defaults = {
			parent: 'div',
			contain: false,
			marginCenter: false,
			delay: 100
		};
		// console.log(opts.contain);

		var opts = $.extend(defaults, opts);

		function positionImage(obj) {
			// reset image (in case we're calling this a second time, for example on resize)
			//obj.css({'width': '', 'height': '', 'margin-left': '', 'margin-top': ''});
			if (opts.marginCenter) {
				obj.css({ 'width': '', 'height': '', 'margin-left': '', 'margin-top': 0 });
			} else {
				obj.css({ 'width': '', 'height': '', 'max-width': 'none' });
			}

			// dimensions of the parent
			var parentWidth = obj.parents(opts.parent).outerWidth() + 5; // To handle antialiasing
			var parentHeight = obj.parents(opts.parent).outerHeight() + 5; // To handle antialiasing

			// dimensions of the image
			var imageWidth = obj.width();
			var imageHeight = obj.height();

			// step 1 - calculate the percentage difference between image width and container width
			var diff = imageWidth / parentWidth;

			// step 2 - if height divided by difference is smaller than container height, resize by height. otherwise resize by width
			// console.log(opts.contain +' | '+ (imageHeight / diff) +' | '+ parentHeight);
			if (imageHeight / diff < parentHeight) {
				obj.css({ 'width': 'auto', 'height': parentHeight });

				// set image variables to new dimensions
				imageWidth = imageWidth / (imageHeight / parentHeight);
				imageHeight = parentHeight;
				// console.log('1');
				if (opts.contain) {
					obj.css({ 'height': 'auto', 'width': parentWidth });
				}
			} else {
				obj.css({ 'height': 'auto', 'width': parentWidth });

				// set image variables to new dimensions
				imageWidth = parentWidth;
				imageHeight = imageHeight / diff;
				// console.log('2');
				if (opts.contain) {
					obj.css({ 'width': 'auto', 'height': parentHeight });
				}
			}

			// step 3 - center image in container
			var leftOffset = (imageWidth - parentWidth) / -2;
			var topOffset = (imageHeight - parentHeight) / -2;

			//obj.css({'margin-left': leftOffset, 'margin-top': topOffset});
			if (opts.marginCenter) {
				obj.css({ 'margin-left': leftOffset, 'margin-top': 0 });
			}
		}

		// run the position function on window resize (to make it responsive)
		var tid;
		var elems = this;

		$(window).on('resize', function () {
			clearTimeout(tid);
			tid = setTimeout(function () {
				elems.each(function () {
					positionImage($(this));
				});
			}, opts.delay);
		});

		return this.each(function () {
			var obj = $(this);

			// hack to force ie to run the load function... ridiculous bug
			// http://stackoverflow.com/questions/7137737/ie9-problems-with-jquery-load-event-not-firing
			obj.attr("src", obj.attr("src"));

			// bind to load of image
			//			obj.load(function() {  // update for jq 3.3 HB 2019-01-09
			obj.on('load', function () {
				positionImage(obj);
			});

			// run the position function if the image is cached
			if (this.complete) {
				positionImage(obj);
			}
		});
	};
})(jQuery);
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
 * Slate Mobile Navigation Menu
 *
 */
(function ($) {

	"use strict";

	// Creates Var for Menu Buttons (Which each expand a sub menu).

	var $expand_menu_button = "<button><span class='button-text'>Toggle Button</span></button>";

	// Selects elements that will have an "opened" appearance and a "closed"
	// appearance. Then adds a class of 'open' when that particular element
	// is clicked.
	$(document).on("click", "#main-menu-toggle", function () {
		$(this).toggleClass("open");
		$(".main-menu").toggleClass("open");
		$(".main-menu > ul[role='menu']").toggleClass("open");
	});

	jQuery(window).on('keydown', function (event) {
		if (event.keyCode == 27) {
			// escape key maps to keycode `27`
			$('#main-menu-toggle').removeClass("open");
			$(".main-menu").removeClass("open");
			$(".main-menu > ul[role='menu']").removeClass("open");
		}
	});

	// If class '.main-menu__item--parent' exists (indicating there is a submenu)
	// Go ahead and add a Menu Button (created in the var above) to give the user the
	// capability to expand the submenu.
	if ($(".main-menu__item--parent")) {
		$(".main-menu__item--parent > a").after($expand_menu_button);
	}

	// Add a class to the menu button when the user clicks it so that it has a
	// different appearance/style when clicked (indicating it has been activated)
	// and thus, the menu expanded.

	$(".main-menu__item--parent button").on("click", function () {
		$(this).toggleClass("rotated_expand-button");
		$(this).siblings("ul.main-menu__submenu").toggleClass("expanded_main-menu__submenu");
	});

	// On focus out event for last menu item in a sub-menu "set", check to see if menu has a button, and if it does, do nothing; otherwise if no button, let the natural order of "tabbing" change the focus from the child a to the child button take place and allow activation of child menu
	$(".main-menu__submenu > li:last-of-type > a").on("focusout", function () {
		// if li:last-of-type does have a button
		if ($(this).closest("li").has("button").length) {
			// (implied: do nothing on this particular focus change - i.e. do not toggle parent toggles)
			// if on focus change FROM button (which is the next natural option)
			$(this).closest("li").children("button").on("focusout", function () {
				// if this button (that we changed the focus from) HAS a class of "rotated_expand-button"
				if ($(this).hasClass("rotated_expand-button")) {
					// Do nothing
					// if this button (that we changed the focus from) does NOT HAVE a class of "rotated_expand-button"
				} else {
					// toggle parent elements' respective classes to "close" the immediate menu
					var expandedMainMenuSubmenu = $(this).closest(".expanded_main-menu__submenu");
					var expandedMainMenuSubmenuButton = $(this).closest(".expanded_main-menu__submenu").siblings("button.rotated_expand-button");
					$(expandedMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
					$(expandedMainMenuSubmenuButton).toggleClass("rotated_expand-button");
				}
			});
			// if li:last-of-type does not have a button
		} else {
			// find the immediate parent toggles and toggle them (to close menu and deactivate rotated menu button)
			var expandedMainMenuSubmenu = $(this).closest(".expanded_main-menu__submenu");
			var expandedMainMenuSubmenuButton = $(this).closest(".expanded_main-menu__submenu").siblings("button.rotated_expand-button");
			$(expandedMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
			$(expandedMainMenuSubmenuButton).toggleClass("rotated_expand-button");
		}
		// and if the focus happens to change to the next top-level parent, close prev menu
		$(this).closest("li.toplevel").next().children("a").on("focusin", function () {
			var previousSiblingMainMenuSubmenu = $(this).closest("li.toplevel").prev("li.toplevel").children("ul.expanded_main-menu__submenu");
			var previousSiblingMainMenuSubmenuButton = $(this).closest("li.toplevel").prev("li.toplevel").children("button.rotated_expand-button");
			$(previousSiblingMainMenuSubmenu).toggleClass("expanded_main-menu__submenu");
			$(previousSiblingMainMenuSubmenuButton).toggleClass("rotated_expand-button");
		});
	});
})(jQuery);

// Adds a "tabindex" attribute to what "should be tab-able" elements -- OPTIONAL
// This isn't necessary IF tabindex attribute doesn't contribute to some sort of solution for FF and Safari tabbing issues; caused by those respective vendors, but not necessarily the markup.
window.addEventListener('load', function () {
	var tabIndexEls = $("ul[role='menu']").find("li > a");
	$(tabIndexEls).each(function (index) {
		$(this).attr("tabindex", 0);
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/
(function () {
	'use strict';

	// rerun lazyload on screen size updates

	window.addEventListener('resize', function () {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	window.addEventListener('load', function () {
		var search_form = jQuery('#search-form');
		var search_input = jQuery('#search-input');
		search_form.click(function (e) {
			if (jQuery(event.target).hasClass('search-form__button') && search_input.val() == "") {
				search_input.focus();
				search.toggleClass('search-form--active');
				event.preventDefault();
			} else {
				search_input.focus();
				search_form.addClass('search-form--active');
			}
		});

		// adds class to nav menu to adjust break points to fit extra menu items
		jQuery('.search-form svg').on('click', function (event) {
			// width determines the width of the search field when expanded
			var windowSize = jQuery(window).width();
			if (windowSize >= 992) {
				console.log("hello");
				event.preventDefault();
				jQuery('.search-form').css('width', '10rem');
				jQuery('.search-form__field').addClass('search-form__focus');
			}
		});

		search_input.focusout(function (event) {
			if (search_input.val() == "") {
				searchForm.removeClass('search-form--active');
			}
		});

		// search child dom elements for a[href], and follow the fist one on click events 2015-11-03
		jQuery(".linkclicker").click(function (e) {
			var _this = jQuery(this);
			if (_this.find("a")) {
				e.preventDefault();
				if (_this.find("a:first").attr("target")) {
					// new tab
					window.open(_this.find("a:first").attr("href"));
				} else {
					// same tab
					window.location = _this.find("a:first").attr("href");
				}
			}
		});

		// 2016-05-15, force opening external links, and pdf's, in new tab.
		if (!jQuery('a').attr('target')) {
			jQuery('a[href^=http]:not([href*="' + dbs.http_host + '"])').attr('target', '_blank').attr('rel', 'noopener');
			jQuery('a[href$=".pdf"]').attr('target', '_blank');
		}

		// Accessible functionality to dismiss dbs text in the footer.
		jQuery('#dbs-chev').on('focus', function (event) {
			$(this).addClass('expand-content');
		}).on('keyup', function (event) {
			if (event.keyCode == 27) {
				// escape key maps to keycode `27`
				$(this).removeClass('expand-content');
			}
		}).on('blur', function (event) {
			$(this).removeClass('expand-content');
		});
		// 2017-09-12, add a X "clear form field" option to these fields:

		// This is causing problems, and from what I can tell, not being used anyway.
		//jQuery( "input[type=text],input[type=email],textarea" ).( { color: "#999" } );

		/**
   * 	The following removes gratuitous p tags inserted by the editor around img tags. 2018-03-28
  	 */
		jQuery(".layout p").each(function () {
			// For each paragraph of .layout class
			if (jQuery(this).find("img").length && // If there's an image
			!jQuery.trim(jQuery(this).text()).length) {
				// and there's no text, then ... get mean.
				jQuery(this).closest("p").find("*").first().addClass("unwrapped").unwrap(); // if the ancestor is a p tag, do what you have to do
			}
		});

		/**
  * Force external links to open in a new tab.
  * 2019-07-11 - TA
  */
		// From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		function link_is_external(link_element) {
			return link_element.host !== window.location.host;
		}

		var anchorElements = document.getElementsByTagName('a');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = anchorElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var anchorElement = _step.value;


				if (link_is_external(anchorElement)) {
					anchorElement.classList.add('external-link');
					anchorElement.setAttribute('target', '_blank');
					anchorElement.setAttribute('rel', 'noopener');

					// Add assistive text to alert of external links
					var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
					var assistiveTextContainer = document.createElement('span');
					assistiveTextContainer.innerHTML = assistiveText;
					anchorElement.appendChild(assistiveTextContainer.firstChild);
				}
			} // END FORCE EXTERNAL LINKS

		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		jQuery('.flickity-prev-next-button').wrapAll('<div class="flickity-button-container"></div>');
		jQuery('.flickity-button-container').insertAfter('#go-to-slider-controls');

		// A total of six blocks should appear in the partial section. The goal of this functionality is to remove the block that pertains to the page a user is currently viewing.
		// Beyond this, the goal is to remove any pages above six, which will ensure that the partial never includes additional blocks or rows of content.
		var blocksCounter = 0;
		var removed = '';

		jQuery('.flex-block__cell').each(function () {
			var pageId = $(this).data('myval'); // Get each flex-block__cell's data attribute (set to the relavant page id of the page the content block links to)

			if (jQuery('body').hasClass(pageId)) {
				$(this).remove(); // Remove the content block that pertains to the page currently being viewed.
			} else {
				blocksCounter++;
			}
			if (blocksCounter > 6) {
				// Removes unneeded blocks to keep grid at 6. nextAll() needs the 'div' selector to keep it from grabbing too many elements.
				jQuery('.flex-block__cell:nth-child(6)').nextAll('div').remove();
			}
		});

		/**
   * Captures Google Analytics Client ID and inputs into hidden form field
   */
		function fillClientId() {
			// no ga on local or staging
			if (typeof ga === "undefined") return;
			// Capture Client ID
			var clientId = ga.getAll()[0].get('clientId');
			// Populate hidden form field with Client ID
			jQuery('.g-id input').val(clientId);
		}

		// On pages with client ID form field, populate
		if (jQuery('.g-id input').length) {
			// Give GTM time to load
			setTimeout(function () {
				fillClientId();
			}, 2000);
		}
	}); // end load event
})();